import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../app-token.service";
import { HttpHandlerService } from "../http-handler.service";

@Injectable({
    providedIn: 'root'
})

export class ReportService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getAllEndPoint = 'reports';
    _getScheduleEndPoint = 'scheduler';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAll(data: any): Observable<any> {
        // console.log("data", data);
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/search`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetAllList(): Observable<any> {
        // console.log("data", data);
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetReportById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
    public Delete(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/${id}`;
        console.log('full_api_url : ', full_api_url);
        const request_options = this._httpHandler.prepareRequest(
            'DELETE',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
    
    public Add(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            JSON.stringify(data)
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public ScheduleReport(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getScheduleEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            JSON.stringify(data)
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
}